<template>

  <v-container fluid class="pa-0">

    <div class="text-subtitle-1 text-center">
      {{ $t('appSignCloudProviderDiia.infoAboutDiiaApp') }}
    </div>

    <div v-if="messageText" v-html="messageText" :class="[ 'info-panel pa-2', messageIsError ? 'error': 'success' ]">
    </div>

  </v-container>

</template>

<script>
import uiMixin from '@/mixins/ui-mixin';
import AppSignBasePrivateKeyReader from '@/sign/components/AppSignBasePrivateKeyReader';

export default {
  name: 'AppSignCloudProviderDiia',
  extends: AppSignBasePrivateKeyReader,
  mixins: [uiMixin],
  data() {
    return {};
  },
  computed: {
    isReadyToSign() {
      return true;
    }
  },
  methods: {
    onComponentBecameVisible() {
      this.eventBus.$emit('app-sign-change-ui-settings', {
        isResetBtnVisible: false
      });
      this.$emit('ready');
    }
  }
};
</script>
